/** In-memory draft cache so closing the import dialog does not lose progress. */

export type ImportWizardStep = "before" | "after" | "review";

export interface CachedStagedMedia {
  id: string;
  file: File;
  previewUrl: string;
  phase: "before" | "after";
  roomName: string;
  isIssue: boolean;
  issueDescription: string;
}

export interface ImportTurnoverDraft {
  step: ImportWizardStep;
  beforeItems: CachedStagedMedia[];
  afterItems: CachedStagedMedia[];
  notes: string;
  markTaskCompleted: boolean;
  extraRooms: string[];
}

const cache = new Map<string, ImportTurnoverDraft>();

export function getImportTurnoverDraft(taskId: string): ImportTurnoverDraft | undefined {
  return cache.get(taskId);
}

export function saveImportTurnoverDraft(taskId: string, draft: ImportTurnoverDraft): void {
  cache.set(taskId, draft);
}

export function clearImportTurnoverDraft(taskId: string): void {
  const draft = cache.get(taskId);
  if (draft) {
    for (const item of [...draft.beforeItems, ...draft.afterItems]) {
      URL.revokeObjectURL(item.previewUrl);
    }
  }
  cache.delete(taskId);
}
